<template>
  <div class="letuopin">
    <div
      class="item"
      v-for="(product, index) in spreadProductsDetail"
      :key="index"
    >
      <div class="item-top">
        <div class="item-content">
          <div class="item-title">{{ product.storeInfo.store_name }}</div>
          <div class="attr">
            【主要成分】{{ product.storeInfo.general_name }}
          </div>
          <div class="attr">
            【规 格】{{ product.productAttr[0].attr_value[0].attr }}
          </div>
          <div class="attr">
            【生产厂家】{{ product.storeInfo.Authorized_holder }}
          </div>
          <div class="attr">【有效期】36个月</div>
          <div class="attr">【适应症】散瞳、睫状肌麻痹</div>
        </div>
        <div class="item-image">
          <img :src="product.storeInfo.image" />
        </div>
      </div>
      <div class="attr">
        <p>【禁忌】</p>
        <p v-html="product.storeInfo.contraindications"></p>
      </div>
      <div class="item-bottom">
        <div class="item-button" @click="$router.push('/clinical-trial')">
          临床试验
        </div>
        <div
          class="item-button"
          @click="$router.push('/listing-certification')"
        >
          上市证明
        </div>
        <div class="item-button" @click="$router.push('/manu-info')">
          厂家资料
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserInfo } from "@api/user";
import { getProductDetail } from "@api/store";
export default {
  name: "AboutLetuopin",
  components: {},
  props: {},
  computed: {},
  data: function() {
    return {
      spreadProducts: [],
      spreadProductsDetail: []
    };
  },
  created() {},
  async mounted() {
    //获取该账号相应的推广商品id
    let userInfo = await getUserInfo();
    this.spreadProducts = userInfo.data.spread_product.split(",");
    let spread = this.$route.query.spread;
    //根据得到的id逐个获取商品详情
    this.spreadProducts.forEach(async product => {
      let productDetail = await getProductDetail(spread, product);
      this.spreadProductsDetail.push(productDetail.data);
    });
    console.log(this.spreadProductsDetail);
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
.letuopin {
  height: 100%;
  background-color: rgb(245, 250, 254);
  padding: 10px 20px;
  .item {
    padding: 20px 10px;
    background-color: #fff;
    border-radius: 10px;
    margin-bottom: 20px;
    &-top {
      display: flex;
      align-items: flex-start;
    }
    &-title {
      color: rgb(72, 172, 240);
      font-size: 26px;
      font-weight: 700;
      padding-left: 6px;
      margin-bottom: 10px;
    }
    &-image {
      // width: 4rem;
      // height: 4rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .attr {
      font-size: 14px;
      margin-bottom: 4px;
    }
    &-bottom {
      display: flex;
      flex-direction: row-reverse;
      margin-top: 20px;
    }
    &-button {
      color: rgb(80, 172, 230);
      border: 1px solid rgb(80, 172, 230);
      border-radius: 14px;
      padding: 4px;
      margin-left: 20px;
    }
  }
}
</style>
